import { OutletRoleEnum } from "./outlet-role-enum";

export const outletRoleLabels = {
  [OutletRoleEnum.RETAIL]: "Retail",
  [OutletRoleEnum.HUB]: "Hub",
}; 